import React, { PureComponent } from 'react';
import {
  ItemContainer,
  Item,
  Label,
  Separator,
  LinkWrapper,
  ExternalLinkWrapper,
} from './elements';
import { paths } from '../../../constants/routes/urls';
import { words } from '../../../constants';

type Props = {
  dropdownEntries: [string, string][];
};

class DropdownItems extends PureComponent<Props> {
  render = (): Array<React.ReactElement> => {
    const { dropdownEntries } = this.props;
    let link = '';

    return dropdownEntries.map((data, index) => {
      switch (data[1]) {
        case words.userDropdown.manuals.LearnFXTrade:
        case words.userDropdown.manuals.FXAutoTrade:
        case words.userDropdown.manuals.StockOverseas:
        case words.userDropdown.manuals.VirtualCurrencies:
        case words.userDropdown.manuals.OverseasBankOpen:
        case words.userDropdown.manuals.CriticalThinking:
        case words.userDropdown.manuals.ProgrammingMastery:
          // putting links to this menu, UNCOMMENT AND CASCADE if else
          // if (data[1] === words.userDropdown.manuals.LearnFXTrade) {
          //   link = paths.fx;
          // }
          switch (data[1]) {
            case words.userDropdown.manuals.LearnFXTrade:
              link = 'https://cod.expert/course/trade/';
              break;
            case words.userDropdown.manuals.FXAutoTrade:
              link = 'https://cod.expert/course/copy-expert/';
              break;
            case words.userDropdown.manuals.StockOverseas:
              link = 'https://cod.expert/course/overseas-stock-investment/';
              break;
            case words.userDropdown.manuals.VirtualCurrencies:
              link = 'https://cod.expert/course/cryptocurrency-trade/';
              break;
            case words.userDropdown.manuals.OverseasBankOpen:
              link = 'https://cod.expert/course/overseas-banks/';
              break;
            case words.userDropdown.manuals.CriticalThinking:
              link = 'https://cod.expert/course/critical-thinking/';
              break;
            case words.userDropdown.manuals.ProgrammingMastery:
              link = 'https://cod.expert/course/ea-programming/';
              break;
            default:
              link = '';
          }
          return (
            <ItemContainer key={data[0]} isBackItem={false}>
              <ExternalLinkWrapper href={link} target={'_blank'}>
                <Item isBackItem={false}>
                  <Label>{data[1]}</Label>
                </Item>
                {index < dropdownEntries.length - 1 && <Separator />}
              </ExternalLinkWrapper>
            </ItemContainer>
          );
        default:
          return (
            <ItemContainer key={data[0]} isBackItem={false}>
              <LinkWrapper
                to={paths[data[0]]}
                target={
                  data[0] === 'privacyPolicy' || data[0] === 'termsOfServices'
                    ? '_blank'
                    : '_self'
                }>
                <Item isBackItem={false}>
                  <Label>{data[1]}</Label>
                </Item>
                {index < dropdownEntries.length - 1 && <Separator />}
              </LinkWrapper>
            </ItemContainer>
          );
      }
    });
  };
}

export default DropdownItems;
